
const getAppLessons = (lessonsArr: { [key: string]: any }[], lesson_id: string) => {
   
    let res = [];

    for (let i = 0; i < lessonsArr.length; i++) {
        if (lessonsArr[i].father_app === lesson_id) {
                res.push(lessonsArr[i])
        }
    }

    return res;
    
}


export default getAppLessons;








